module.exports = __webpack_public_path__ + "static/live-3f232e25dc79db8e8e8fe23e47e6c4f2.png";